<div class="inline-add-panel" [class.overlay-mode]="isOverlay" *ngIf="visible">
    <div class="panel-content">
        <div class="panel-header-inline">
            <h4 class="panel-title">
                {{ config.title || 'Add New' }}
            </h4>
            <button type="button" nz-button nzType="text" nzSize="small" (click)="onCancel()" class="close-button">
                <span nz-icon nzType="close"></span>
            </button>
        </div>

        <form nz-form [formGroup]="formGroup" #form="ngForm" [nzLayout]="'vertical'">
            <div class="form-grid">
                <div class="form-row" [ngClass]="getFieldSizeClass(field)"
                    *ngFor="let field of config.fields; let i = index"
                    [style.display]="field.name === 'supplierCode' || field.name === 'customerCode' ? 'none' : 'block'">
                    <nz-form-item>
                        <nz-form-label [nzRequired]="field.required">
                            {{ field.label }}

                        </nz-form-label>
                        <nz-form-control [nzErrorTip]="getFieldError(field.name)">

                            <!-- Text, Email, Number inputs -->
                            <input
                                *ngIf="(field.type === 'text' || field.type === 'email' || field.type === 'number') && field.name !== 'customerCode' && field.name !== 'supplierCode'"
                                nz-input [formControlName]="field.name" [type]="getFieldType(field)"
                                [placeholder]="field.placeholder || 'Enter ' + field.label.toLowerCase()"
                                [maxlength]="field.maxLength || null" />

                            <!-- Auto Code for Customer Code -->
                            <app-auto-code *ngIf="field.name === 'customerCode'" [formControlName]="field.name"
                                [isNew]="true" [companyName]="getCompanyName()"
                                [controlAccount]="getControlAccountCode()" type="AR" [maxlength]="field.maxLength || 50"
                                #autoCodeComponent>
                            </app-auto-code>

                            <!-- Auto Code for Supplier Code -->
                            <app-auto-code *ngIf="field.name === 'supplierCode'" [formControlName]="field.name"
                                [isNew]="true" [companyName]="getCompanyName()"
                                [controlAccount]="getControlAccountCode()" type="AP" [maxlength]="field.maxLength || 20"
                                #autoCodeComponent>
                            </app-auto-code>


                            <!-- Textarea -->
                            <textarea *ngIf="field.type === 'textarea'" nz-input [formControlName]="field.name"
                                [placeholder]="field.placeholder || 'Enter ' + field.label.toLowerCase()"
                                [maxlength]="field.maxLength || null" [nzAutosize]="{ minRows: 3, maxRows: 5 }">
                            </textarea>

                            <!-- Select dropdown (Static) -->
                            <nz-select *ngIf="field.type === 'select' && !field.searchConfig" [formControlName]="field.name"
                                [nzPlaceHolder]="field.placeholder || 'Select ' + field.label.toLowerCase()"
                                nzShowSearch [nzAllowClear]="!field.required" [nzDropdownMatchSelectWidth]="false"
                                nzDropdownClassName="inline-panel-select-dropdown"
                                (ngModelChange)="field.name === 'controlAccountId' ? onControlAccountChange() : null">
                                <nz-option *ngFor="let option of field.options" [nzValue]="option.value"
                                    [nzLabel]="option.label">
                                </nz-option>
                            </nz-select>

                            <!-- Select dropdown (Server Search) -->
                            <nz-select *ngIf="field.type === 'select' && field.searchConfig" [formControlName]="field.name"
                                [nzPlaceHolder]="field.placeholder || 'Select ' + field.label.toLowerCase()"
                                nzShowSearch nzServerSearch [nzAllowClear]="!field.required" [nzDropdownMatchSelectWidth]="false"
                                nzDropdownClassName="inline-panel-select-dropdown"
                                [nzFilterOption]="nzFilterOption"
                                (nzOnSearch)="onSelectSearch(field.name, $event)"
                                (nzScrollToBottom)="loadMoreSelectOptions(field.name)"
                                [nzLoading]="getSelectLoading(field)"
                                (ngModelChange)="field.name === 'controlAccountId' ? onControlAccountChange() : null">
                                <nz-option *ngFor="let option of getSelectOptions(field)" 
                                    [nzValue]="option[field.searchConfig.valueField || 'id']"
                                    [nzLabel]="option[field.searchConfig.labelField || 'code']"
                                    nzCustomContent>
                                    <span>{{ option[field.searchConfig.labelField || 'code'] }}</span>
                                    <span *ngIf="option.name"> : {{ option.name }}</span>
                                </nz-option>
                            </nz-select>

                            <!-- Radio Group -->
                            <nz-radio-group *ngIf="field.type === 'radio-group'" [formControlName]="field.name"
                                nzButtonStyle="solid">
                                <label *ngFor="let option of field.options" nz-radio-button [nzValue]="option.value">
                                    {{ option.label }}
                                </label>
                            </nz-radio-group>

                            <!-- Switch -->
                            <nz-switch *ngIf="field.type === 'switch'" [formControlName]="field.name">
                            </nz-switch>

                        </nz-form-control>
                    </nz-form-item>
                </div>
            </div>
        </form>

        <div class="panel-footer-inline">
            <div class="footer-content" [class.no-more-details]="!shouldShowMoreDetailsButton()">
                <div class="more-details-link" *ngIf="shouldShowMoreDetailsButton()">
                    <a (click)="onMoreDetails()" class="more-details-btn">
                        <span nz-icon nzType="plus"></span>
                        More details
                    </a>
                </div>
                <div class="button-group">
                    <button type="button" nz-button nzType="default" (click)="onCancel()" [disabled]="loading">
                        {{ config.cancelButtonText || 'Cancel' }}
                    </button>
                    <button type="button" nz-button nzType="primary" class="ant-btn ant-btn-primary" (click)="onSubmit()"
                        [nzLoading]="loading" [disabled]="!formGroup.valid || loading">
                        {{ config.submitButtonText || 'Save' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>